module.exports = __webpack_public_path__ + "img/carnaval.4fb909a7.png";